module.exports = __webpack_public_path__ + "img/index-item4.7afe4f74.png";